import React from 'react'
import { FieldProps } from '../FormDuuf'

// Elements
import Label from '../elements/Label'
import Error from '../elements/Error'

const FileUploadField: React.FC<FieldProps> = ({ formik = { handleChange: () => null, values: {} }, hasError = false, fieldId, data }) => {
  const inputRef: React.RefObject<HTMLInputElement> = React.useRef(null)

  let accept: string = ''

  if (data.allowedExtensions) {
    const extensions: Array<string> = data.allowedExtensions.split(',')

    extensions.forEach((extension) => {
      accept += `${accept !== '' ? ',' : ''}application/${extension},image/${extension}`
    })
  }

  return (
    <div className={`form-duuf-group form-duuf-group-${data.type} position-relative`}>
      <Label fieldId={fieldId} data={data} />
      <Error fieldId={fieldId} data={data} hasError={hasError} formik={formik} />
      <div className="form-duuf-file d-flex align-items-center">
        <input
          type="file"
          onChange={(event) => {
            const {
              target: { files }
            }: any = event

            for (let i = 0; i < files.length; i += 1) {
              // @ts-ignore
              formik.handleChange({
                target: {
                  name: fieldId,
                  value: files[i]
                }
              })
            }
          }}
          id={fieldId}
          name={fieldId}
          ref={inputRef}
          accept={accept}
          className="form-duuf-file-input d-none"
        />
        <span className="form-duuf-file-button">
          <button
            type="button"
            onClick={() => {
              inputRef?.current?.click()
            }}
          >
            {data.description}
          </button>
        </span>
        {formik.values[fieldId] && <div className="form-duuf-file-name">{formik.values[fieldId].name}</div>}
      </div>
    </div>
  )
}

export default FileUploadField
